import { Component, inject } from '@angular/core';
import { ToastService } from '../../state/toast/toast.service';
import { AsyncPipe } from '@angular/common';
import { ToastComponent } from '../toast/toast.component';

@Component({
  selector: 'app-toast-container',
  imports: [ToastComponent, AsyncPipe],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.css',
})
export class ToastContainerComponent {
  private toastService = inject(ToastService);
  protected toasts;

  constructor() {
    const toastService = this.toastService;
    this.toasts = toastService.toasts$;
  }
  close(id: string) {
    this.toastService.removeToast(id);
  }
}
